type order_type = 1 | -1;

export const handleSortByValue = (list: Array<any>, key: string, order: order_type): Array<any> => {
    return list.sort((a, b) => {
      if (a[key] < b[key]) return order * (-1);
      if (a[key] > b[key]) return  order;
      return 0;
    });
}